import React from 'react';
import ImageSlideShow from '../layout/ImageSlideShow';

import styling from './DramaClub.module.css';


const DramaClub = () => {
    const shows = [
      {
        title: "",
        src: "/files/dramskiKlub/1.jpg",
        alt: "Преображај.jpg",
        text: ""
      },
      {
        title: "",
        src: "/files/dramskiKlub/2.jpg",
        alt: "Рибар и његова душа.jpg",
        text: ""
      },
      {
        title: "",
        src: "/files/dramskiKlub/3.jpg",
        alt: "Животињска фарма.jpg",
        text: ""
      },
      {
        title: "",
        src: "/files/dramskiKlub/4.jpg",
        alt: "10 малих црнаца.jpg",
        text: ""
      },
      {
        title: "",
        src: "/files/dramskiKlub/5.jpg",
        alt: "Како је мачак Зорба научио галебицу да лети.jpg",
        text: ""
      },
      {
        title: "",
        src: "/files/dramskiKlub/6.jpg",
        alt: "У раљама живота.jpg",
        text: ""
      },
      {
        title: "",
        src: "/files/dramskiKlub/7.jpg",
        alt: "Љубав и њена агрегатна стања.jpg",
        text: ""
      },
      {
        title: "",
        src: "/files/dramskiKlub/8.jpg",
        alt: "Једну карту молим.jpg",
        text: ""
      },
      {
        title: "",
        src: "/files/dramskiKlub/9.jpg",
        alt: "Ко је луд да буде нормалан.jpg",
        text: ""
      },
      {
        title: "",
        src: "/files/dramskiKlub/10.jpg",
        alt: "Мандала.jpg",
        text: ""
      }
    ];

    return (
      <div>
        <img className={styling.logoSekcije} src="/files/dramskiKlub/logoDramskogKluba.jpg" alt="Лого Драмски клуб"/>
        <h3>Од драмске секције до драмског клуба</h3>
        <p>Увек долазак нових људи, у овом случају професорке Валентине (Јанковић) Паровић донесе и нове  идеје. Не поставља се питање да ли је пре ње постојала или нешто радила Драмска секција, него нема података о томе. Већ у зиму 1990. године поставило је десетак ученика на челу с професорком две једночинке које су изведене у школи.</p>
        <p>Спремала се прослава 125 година постојања Гимназије 1991.године и то је била идеална прилика да Драмска секција изађе из ове установе. За Дан школе, 7.12.1991. извели су у Културном центру представу “Школастика” према тексту Николе Стојшина, а у режији Валентине (Јанковић) Паровић и двадесетак ђака.</p>
        <p>Уследила је пауза у раду до доласка Јелене (Херцег) Журић, која ће основати Драмски клуб 4.октобра 1995.године. Аудиција је окупила многобројне заинтересоване гимназијалце, да би у мају 1996.године била премијера у нашем граду. Те године основани су Позоришни сусрети у Крагујевцу где је учествовало шест Гимназија, а и наша је била међу њима.</p>
        <p>Наредне школске године, нова представа, исти ментор, професорка Јелена Журић.
Драмски клуб ове године, 1998. води професорка Мира Паталов и са ђацима припрема нову представу, која учествује , као и претходне две на Сусретима у Крагујевцу. Број учесника на Позоришним сусретима повећао се на дванаест.</p>
        <p>Интересовање ђака за рад у Драмском клубу је велики и једна представа не може да задовољи толики број заинтересованих. Наметнула се нова замисао, као потпуно природан след догађаја.  Професорка Ксенија Беч,  претходне три године припремала је дечије  представе са ученицима једног одељења, које су извођене приликом доделе пакетића професорској деци, али су уговарана и гостовања по предузећима, где смо радовали децу, а ми добили послужење. Радост и весеље били су обострани. Од 1999. године, ментор Драмског клуба постаје професорка Ксенија Беч. Почиње се рад на представи “Жак или покорност” на основу текста Ежена Јонеска, а у режији Милана Ђукановића, ученика четвртог разреда. Друга група ђака ради на припремању текста “Заједнички стан”, у режији ученика четвртог разреда и углавном учесника претходне представе, која је изведена 1998.године. План је био да обе буду изведене у нашем граду, а затим боља да буде пласирана на Сусрете у Крагујевац, који указом Министарства постају Републичко такмичење Драмских клубова гимназија од ове године. Због бомбардовања, представе нису изведене.</p>
        <p>Иако је претходна година била бурна, Клуб не посустаје с радом. На иницијативу ђака трећег разреда почиње се са припремама на новој представи. Ова година била је преломна за Клуб из више разлога. Изашли смо из Школе, направили сарадњу са Културним центром и тамо, на правој сцени имали пробе.Схватили смо да осим успомена, неких фотографија,мора да остане неки траг о животу представе, а то је плакат. Енергија и радост играња која је постојала није смела да се изгуби. Неговали смо то и из године у годину имали нову представу. Проблеме око израде сценографије, путовања у Крагујевац и од 2003. гостовања и у Новом Саду на Школском позорју, морали смо некако и финансијски да решимо. Клуб је имао подршку директора Школе, проналазила су се средства и некако смо успевали да сва та такмичења  испратимо. Ипак, од 2005. пронађен је неки модус финансирања. Наиме, од продатих улазница имали смо приход, а с јесени смо играли репризу представе и то нам је био почетни капитал за нову представу. Два пута нам је град помогао, тако што су нам одобрили средства на пројекат, имали смо сталне спонзоре, а увек се пронашао још неко ко је желео да помогне.  Од 2006.године Драмски клуб има још једног сталног члана, Слађана Ристића, који заједно са ученицима израђује сцену, помажући им да се замисао не сруши, у буквалном смислу.</p>
        <p>Интересовање за рад је огромно, сви би нешто да раде само да буду део тима. На припреми сваке представе радило је између тридесет и четрдесет ђака.</p>
        <p>У свим адаптацијама које је наш Драмски клуб радио, имали смо за циљ да покажемо с којим се све проблемима и дилемама сусрећу њихови вршњаци. Од љубави и на шта је све  човек спреман да уради у то име, преко приче о поштовању и уважавању разлика међу људима, или куда нас то алкохол води до приче о несналажењу и неприлагођености у овом свету. Када се погледају представе које су изведене за ових 16 година, види се њихова различитост, како жанровски, тако и у техничком и сценском смислу. Експериментисало се и проналазила су се решења, некад боља некад лошија, али проналазила су се.У сваком случају драмска секција је одавно изашла из њеног оквира и постала заиста Драмски клуб, који је на неки начин институција за себе у оквиру Школе.</p>
        <p>Ксенија Беч</p>

        <div>
            <ImageSlideShow images={shows} />
        </div>

      </div>
    );
}

export default DramaClub;


/*
<div className={[styling.posterSection, styling.wrap].join(" ")}>
  <div className={styling.poster}>
    <img src="/files/dramskiKlub/1.jpg" alt="Представа: Преображај"/>
  </div>
  <div className={styling.poster}>
    <img src="/files/dramskiKlub/2.jpg" alt="Представа: Рибар и његова душа"/>
  </div>
  <div className={styling.poster}>
    <img src="/files/dramskiKlub/3.jpg" alt="Представа: Животињска фарма"/>
  </div>
  <div className={styling.poster}>
    <img src="/files/dramskiKlub/4.jpg" alt="Представа: 10 малих црнаца"/>
  </div>
  <div className={styling.poster}>
    <img src="/files/dramskiKlub/5.jpg" alt="Представа: Како је мачак Зорба научио галебицу да лети"/>
  </div>
  <div className={styling.poster}>
    <img src="/files/dramskiKlub/6.jpg" alt="Представа: У раљама живота"/>
  </div>
  <div className={styling.poster}>
    <img src="/files/dramskiKlub/7.jpg" alt="Представа: Љубав и њена агрегатна стања"/>
  </div>
  <div className={styling.poster}>
    <img src="/files/dramskiKlub/8.jpg" alt="Представа: Једну карту молим"/>
  </div>
  <div className={styling.poster}>
    <img src="/files/dramskiKlub/9.jpg" alt="Представа: Ко је луд да буде нормалан"/>
  </div>
  <div className={styling.poster}>
    <img src="/files/dramskiKlub/10.jpg" alt="Представа: Мандала"/>
  </div>
</div>

*/
